module.exports = __webpack_public_path__ + "static/img/model-bg17.916aee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg17.jpg
// module id = yrjU
// module chunks = 0